import { Chip } from '@material-ui/core'
import React from 'react'

export default function Tags({ tagsArr }) {
  return tagsArr.map(item => (
    <Chip style={{ marginRight: 5 }} key={item.id} label={item.tag} />
  ))
}
